var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      attrs: {
        visible: _vm.internalVisible,
        title: _vm.title + "業務員資料",
        top: "5vh",
        width: "30%",
        "append-to-body": "",
        "show-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.internalVisible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c("el-card", { staticClass: "box-card" }, [
                _c(
                  "div",
                  { staticClass: "leader-data" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "dynamicValidateForm",
                        attrs: {
                          model: _vm.formData,
                          disabled: !_vm.authEdit && !_vm.isAdd,
                        },
                      },
                      [
                        _vm.isAdmin
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "所屬旅行社",
                                  "label-width": _vm.formLabelWidth,
                                  prop: "agencyCode",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      disabled: !!_vm.agencyCode,
                                      filterable: "",
                                      placeholder: "請選擇",
                                    },
                                    model: {
                                      value: _vm.formData.agencyCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "agencyCode",
                                          $$v
                                        )
                                      },
                                      expression: "formData.agencyCode",
                                    },
                                  },
                                  _vm._l(_vm.agencyList, function (item) {
                                    return _c("el-option", {
                                      key: item.key,
                                      attrs: {
                                        label: item.val,
                                        value: item.key,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "業務員姓名",
                              "label-width": _vm.formLabelWidth,
                              prop: "name",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入業務員姓名",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: _vm.formData.name,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "name", $$v)
                                },
                                expression: "formData.name",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "業務員暱稱",
                              "label-width": _vm.formLabelWidth,
                              prop: "nickName",
                              rules: [
                                {
                                  required: false,
                                  message: "請輸入業務員暱稱",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: _vm.formData.nickName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "nickName", $$v)
                                },
                                expression: "formData.nickName",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "業務員電話",
                              "label-width": _vm.formLabelWidth,
                              prop: "mobile",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入業務員電話",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: _vm.formData.mobile,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "mobile", $$v)
                                },
                                expression: "formData.mobile",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "業務員Email",
                              "label-width": _vm.formLabelWidth,
                              prop: "mail",
                              rules: [
                                {
                                  required: true,
                                  message: "請輸入業務員Email",
                                  trigger: "blur",
                                },
                                {
                                  pattern: _vm.formRules.email,
                                  message: "Email格式不正確",
                                  trigger: "blur",
                                },
                              ],
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: _vm.formData.mail,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "mail", $$v)
                                },
                                expression: "formData.mail",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "業務員LineID",
                              "label-width": _vm.formLabelWidth,
                              prop: "lineID",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: { autocomplete: "off" },
                              model: {
                                value: _vm.formData.lineID,
                                callback: function ($$v) {
                                  _vm.$set(_vm.formData, "lineID", $$v)
                                },
                                expression: "formData.lineID",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _vm.isAdd || _vm.authEdit
            ? _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.handleSubmitForm },
                },
                [_vm._v(" 儲 存 ")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { type: _vm.isAdd || _vm.authEdit ? "" : "danger" },
              on: {
                click: function ($event) {
                  _vm.internalVisible = false
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.isAdd || _vm.authEdit ? "取 消" : "關 閉") +
                  " "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }